import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType, VaultStorageTier } from '@repo/api-gw-sdk';
import { useCallback, useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
import { COLD_TIER_SUPPORTED_RESOURCE_TYPES } from '@/utils/vaultStorageTier';
export type GetBackupPolicyAvailableTypes = (policyType: BackupPolicyType, vaultStorageTier: VaultStorageTier) => ResourceType[];
export function useBackupPolicyAvailableTypes() {
  const $ = _c(57);
  const {
    GcpVmHighFrequencyBackupEnabled,
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    MongoAtlasSupport,
    AwsRdsNativeBackupSupport,
    AwsEksClusterBackupSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport,
    AzureNativeVmBackupSupport
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== GcpVmHighFrequencyBackupEnabled) {
    t0 = GcpVmHighFrequencyBackupEnabled ? [ResourceType.GcpComputeEngineInstance] : [];
    $[0] = GcpVmHighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== RdsHighFrequencyBackupEnabled) {
    t1 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[2] = RdsHighFrequencyBackupEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== MongoAtlasSupport) {
    t2 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[4] = MongoAtlasSupport;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = [ResourceType.AwsEc2, ...t0, ...t1, ResourceType.AwsDynamoDb, ResourceType.AwsKeyspacesTable, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t2];
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const HighFrequencySupportedResourceTypes = t3;
  let t4;
  if ($[10] !== AzureSqlVirtualMachineSupport) {
    t4 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[10] = AzureSqlVirtualMachineSupport;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== SapHanaPitrSupport) {
    t5 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[12] = SapHanaPitrSupport;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = [...t4, ...t5];
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const pitrPolicySupportedResourceTypes = t6;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [ResourceType.AwsRds];
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const nativePitrPolicySupportedResourceTypes = t7;
  let t8;
  if ($[18] !== EnableBigQueryNativePolicy) {
    t8 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[18] = EnableBigQueryNativePolicy;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const bigQueryNativePitrSupportedResourceTypes = t8;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [ResourceType.AzureSqlDatabase];
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const azureSqlDatabaseNativePitrSupportedResourceTypes = t9;
  let t10;
  if ($[21] !== AwsRdsNativeBackupSupport) {
    t10 = AwsRdsNativeBackupSupport ? [ResourceType.AwsRds] : [];
    $[21] = AwsRdsNativeBackupSupport;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== AwsEksClusterBackupSupport) {
    t11 = AwsEksClusterBackupSupport ? [ResourceType.AwsEksCluster] : [];
    $[23] = AwsEksClusterBackupSupport;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t10, ...t11];
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t12;
  let t13;
  if ($[28] !== AzureNativeVmBackupSupport) {
    t13 = [ResourceType.AzureFileShare, ...(AzureNativeVmBackupSupport ? [ResourceType.AzureVirtualMachine] : [])];
    $[28] = AzureNativeVmBackupSupport;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const azureFilesPolicySupportedResourceTypes = t13;
  let t14;
  if ($[30] !== GoogleWorkspaceSupport) {
    t14 = [...(GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [])];
    $[30] = GoogleWorkspaceSupport;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const googleWorkspacePolicySupportedResourceTypes = t14;
  let t15;
  if ($[32] !== Microsoft365Support) {
    t15 = [...(Microsoft365Support ? [ResourceType.Microsoft365Resource] : [])];
    $[32] = Microsoft365Support;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const microsoft365PolicySupportedResourceTypes = t15;
  let t16;
  if ($[34] !== EntraIdSupport) {
    t16 = [...(EntraIdSupport ? [ResourceType.AzureEntraIdResource] : [])];
    $[34] = EntraIdSupport;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const entraIdPolicySupportedResourceTypes = t16;
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [ResourceType.AwsRds, ResourceType.AzureVirtualMachine];
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const dualSupportedResourceTypes = t17;
  let t18;
  if ($[37] !== allTypes || $[38] !== awsNativeStandardPolicySupportedResourceTypes || $[39] !== azureFilesPolicySupportedResourceTypes) {
    let t19;
    if ($[41] !== awsNativeStandardPolicySupportedResourceTypes || $[42] !== azureFilesPolicySupportedResourceTypes) {
      t19 = type => (!awsNativeStandardPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && (!azureFilesPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && type !== ResourceType.GoogleWorkspaceResource && type !== ResourceType.Microsoft365Resource && type !== ResourceType.AzureEntraIdResource;
      $[41] = awsNativeStandardPolicySupportedResourceTypes;
      $[42] = azureFilesPolicySupportedResourceTypes;
      $[43] = t19;
    } else {
      t19 = $[43];
    }
    t18 = [...allTypes.filter(t19)];
    $[37] = allTypes;
    $[38] = awsNativeStandardPolicySupportedResourceTypes;
    $[39] = azureFilesPolicySupportedResourceTypes;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const standardPolicySupportedResourceTypes = t18;
  let t19;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = [];
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== HighFrequencySupportedResourceTypes || $[46] !== awsNativeStandardPolicySupportedResourceTypes || $[47] !== azureFilesPolicySupportedResourceTypes || $[48] !== bigQueryNativePitrSupportedResourceTypes || $[49] !== entraIdPolicySupportedResourceTypes || $[50] !== googleWorkspacePolicySupportedResourceTypes || $[51] !== microsoft365PolicySupportedResourceTypes || $[52] !== pitrPolicySupportedResourceTypes || $[53] !== standardPolicySupportedResourceTypes) {
    t20 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR]: azureSqlDatabaseNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE]: googleWorkspacePolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_MICROSOFT_365]: microsoft365PolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_ENTRA_ID]: entraIdPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t19
    };
    $[45] = HighFrequencySupportedResourceTypes;
    $[46] = awsNativeStandardPolicySupportedResourceTypes;
    $[47] = azureFilesPolicySupportedResourceTypes;
    $[48] = bigQueryNativePitrSupportedResourceTypes;
    $[49] = entraIdPolicySupportedResourceTypes;
    $[50] = googleWorkspacePolicySupportedResourceTypes;
    $[51] = microsoft365PolicySupportedResourceTypes;
    $[52] = pitrPolicySupportedResourceTypes;
    $[53] = standardPolicySupportedResourceTypes;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  const supportedResourceTypes = t20;
  const policySupportedResourceTypes = supportedResourceTypes;
  let t21;
  if ($[55] !== policySupportedResourceTypes) {
    t21 = (policyType, vaultStorageTier) => {
      const availableTypes = policySupportedResourceTypes[policyType];
      return vaultStorageTier === VaultStorageTier.VAULT_STORAGE_TIER_COLD ? availableTypes.filter(_temp) : availableTypes;
    };
    $[55] = policySupportedResourceTypes;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  return t21;
}
function _temp(resourceType) {
  return COLD_TIER_SUPPORTED_RESOURCE_TYPES.includes(resourceType);
}